import React, { Component } from "react";
import { Row, Col } from "antd";
import RmxImg from "../../assets/images/rmx-step.png";
import { connect } from "react-redux";
import { UserAction, AuthAction } from "../../store/actions";

class WelcomeContainer extends Component {
  componentDidMount() {
    const userId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[2]
      ?.rmx_company_user?.id;
    this.props.getUserDetail(userId);
  }
  render() {
    console.log("hhh=>", this.props.userDetails);
    return (
      <Row>
        <Col
          xl={24}
          sm={24}
          xs={24}
          lg={24}
          md={24}
          style={{ minHeight: "300px", background: "white", marginTop: "20px" }}
        >
          <Row
            justify="space-between"
            className="m-auto"
            style={{ padding: "2%" }}
          >
            <Col xl={12} lg={12} xs={24} md={24}>
              <h4
                className="text-left"
                style={{ fontWeight: "500", fontSize: "20px" }}
              >
                Welcome to{" "}
                {`${this.props.userDetails?.first_name} ${this.props.userDetails?.last_name}`}
              </h4>
              <p className="text-left">
                Follow the steps below to get started using TRKR and experience
                the ease of collaboration including logistics via the
                confirmation of a pending contractor order.
              </p>
              <p className="text-left">
                In the pending file you will be instructed to select an order to
                reject or approve and then dispatch and assign drivers. Once
                assigned the driver will be able to download a demo app and
                complete the order through TRKR MOBILE.
              </p>
              <p className="text-left">
                To schedule a personalized demonstration of all the features of
                this innovative platform, please contact:
              </p>
              <Row>
                <Col xl={10} lg={10} xs={24} md={24} className="green-sec">
                  <span className="d-block">MAIN FRAME</span>
                  <span className="d-block">+1 619 880 0265</span>
                  <span className="d-block">demo@main-frame.com</span>
                </Col>
              </Row>
            </Col>
            <Row justify="space-between">
              <Col xl={12} lg={12} xs={12} md={12}>
                <img
                  height="120"
                  width="120"
                  className="border-rounded pointer-cursor"
                  src={this.props.userDetails?.image?.original}
                  style={{ objectFit: "cover" }}
                  // className='pointer-cursor'
                  // src={
                  //   "https://s3-us-west-2.amazonaws.com/surface-tech-bucket-staging/images/profile-default.jpg"
                  // }
                />
              </Col>
            </Row>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify="center">
            <Col xl={24} lg={24} xs={1} sm={12} md={12}>
              <a href="https://surface-tech.com/etools/trkr-video/">
                <img
                  src={RmxImg}
                  style={{ objectFit: "cover" }}
                  width={"100%"}
                />
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    userDetails: store.UserReducer.userDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserDetail: (userId) => dispatch(UserAction.getUserDetailReq(userId)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(WelcomeContainer);
